var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFireSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.433 0C4.599 2.214 5.058 8.433 5.058 8.433C5.058 8.433 3.375 7.866 3.375 5.337C1.359 6.507 0 8.757 0 11.25C0 14.976 3.024 18 6.75 18C10.476 18 13.5 14.976 13.5 11.25C13.5 5.769 8.433 4.644 8.433 0ZM7.335 15.678C5.976 16.02 4.608 15.192 4.266 13.833C3.924 12.474 4.752 11.106 6.111 10.764C9.387 9.945 9.792 8.109 9.792 8.109C9.792 8.109 11.421 14.661 7.335 15.678Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFireSign);
export default __webpack_public_path__ + "static/media/fireSign.1e5c0464e08af57692058e4190f031eb.svg";
export { ForwardRef as ReactComponent };